import m from 'mithril';
import '@awesome.me/webawesome/dist/components/dialog/dialog.js';

/**
 * Modal dialog attrs.
 */
export interface ModalAttrs extends m.Attributes {
  /** Whether the dialog is open. */
  open: boolean;
  /** Accessible dialog label. */
  label: string;
  /** Close callback. */
  onClose?: () => void;
}

/**
 * Renders a Webawesome modal dialog.
 */
export const Modal: m.Component<ModalAttrs> = {
  view: ({ attrs, children }) => {
    return m('wa-dialog', {
      open: attrs.open,
      label: attrs.label,
      'light-dismiss': true,
      'onwa-hide': () => {
        attrs.onClose?.();
      },
    }, children);
  },
};
